import { render, staticRenderFns } from "./PuntosDeVentaListado.vue?vue&type=template&id=cab075f8"
import script from "./PuntosDeVentaListado.vue?vue&type=script&lang=js"
export * from "./PuntosDeVentaListado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports